var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticStyle:{"background-color":"#f3f6f9"}},[_c('v-main',[(_vm.isAdmin)?_c('ServiceRequestsComp'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }